import { z } from 'zod';
import { dateSchema, datetimeLocalSchema, modelSchema } from '@/entities/base';

const basePlanSchema = z.object({
  period: z.enum(['week', 'day', 'quarter', 'year']),
  startAtLocal: datetimeLocalSchema,
  startAt: dateSchema,
  status: z.enum(['created', 'checked-in']),
});

export const planSchema = basePlanSchema.extend(modelSchema.shape);

export const planCreateSchema = basePlanSchema
  .pick({
    period: true,
    startAtLocal: true,
    startAt: true,
  })
  .extend({
    id: z.guid(),
  });

export const planUpdateSchema = basePlanSchema.pick({ status: true }).partial();
